module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: " weex-ct weex-div",
    attrs: {
      "weex-type": "div"
    }
  }, [(_vm.show) ? _c('figure', {
    directives: [{
      name: "weex-resize",
      rawName: "v-weex-resize",
      value: ("contain"),
      expression: "\"contain\""
    }],
    staticClass: " weex-el weex-image",
    style: (_vm._px2rem(_vm.loadingStyle, 75)),
    attrs: {
      "src": _vm.PART,
      "resize": "contain",
      "quality": "original",
      "data-img-src": _vm.PART,
      "weex-type": "image"
    }
  }) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9b1c1d46", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b1c1d46","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/dof-part-loading/index.vue
// module id = 660
// module chunks = 0 1